import { Button } from "react-migration/components/Button";
import { AutocompleteResult, SearchAutocompleteSection } from "../types";
import { ListSection } from "./ListSection";

interface RecentSelectionsContentProps {
  hydratedRecentSelections: Array<{
    result: AutocompleteResult;
    section: SearchAutocompleteSection;
  }>;
  highlightedIndex: number;
  isMouseActive: boolean;
  handleSelect: (
    result: AutocompleteResult,
    section: SearchAutocompleteSection,
    options?: { skipRecentUpdate?: boolean }
  ) => void;
  highlightedRef: React.RefObject<HTMLButtonElement>;
  clearRecentSelections: () => void;
}

export function RecentSelectionsContent({
  hydratedRecentSelections,
  highlightedIndex,
  isMouseActive,
  handleSelect,
  highlightedRef,
  clearRecentSelections,
}: RecentSelectionsContentProps) {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mt-3 mb-1">
        <h3 className="ml-2 text-xs font-medium text-text-base-tertiary">Recent</h3>
        <Button variant="ghost" size="xs" disabled={!hydratedRecentSelections.length} onClick={clearRecentSelections}>
          Clear recent
        </Button>
      </div>
      {hydratedRecentSelections.length > 0 ? (
        <ol className="flex flex-col gap-2 m-0 list-none divide-y appearance-none divide-border-base-divider">
          <ListSection
            title=""
            items={hydratedRecentSelections}
            highlightedIndex={highlightedIndex}
            isMouseActive={isMouseActive}
            onSelect={({ result, section }) => handleSelect(result, section, { skipRecentUpdate: true })}
            highlightedRef={highlightedRef}
          />
        </ol>
      ) : (
        <div className="p-2 pb-1 text-xs font-medium text-text-base-secondary">No recent searches…</div>
      )}
    </div>
  );
}
